import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-11-20T00:00:00-0800.
 */
export function useSpaceOpsSrBulkActionsEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.SpaceOpsSrBulkActions, false);

  return Boolean(isEnabled);
}

